export default __webpack_public_path__ + "static/media/face6.0b74b92c.svg";